import { call, put } from 'redux-saga/effects';
import { setServiceOffering, setServiceOfferingFetching } from './actions';

import { fetchServices } from '../../api/services';
import { ServiceOffering } from '../../api/services.types';

export function* getServiceOfferingList() {
  yield put(setServiceOfferingFetching(true));
  const data: ServiceOffering[] = yield call(fetchServices);
  if (data) {
    yield put(setServiceOffering(data));
  }
  yield put(setServiceOfferingFetching(false));
}
